// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list-item[data-v-5e923f6e]{min-height:0!important}.v-list-item .v-list-item__avatar[data-v-5e923f6e]{align-self:start}.border-4[data-v-5e923f6e]{border-radius:10px!important}.add-to-cart__container[data-v-5e923f6e]{bottom:-18px;position:absolute}.avatar-wrapper[data-v-5e923f6e]{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
